import React, { Fragment, useEffect, useState } from 'react'

//Helpers
import { findEnvironments } from '@helpers/helper.unities'
import { group_Unities } from '@helpers/helper.developments'

import useQueryUnities from '@hooks/useQueryUnities'
import { getShortOperation } from '@helpers/helper.properties'
import { RealEstateDataPageComponentData } from 'types'
import { Link } from 'gatsby'
import { ElementHTML } from '@helpers/helper.rendering'
import { adapt_unities_data, findEnvironmentsMediacore } from '@helpers/helper.mediacore'

interface ExternalProps {
  developmentID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const UnitiesDevelopment_1 = ({
  developmentID,
  title,
  paragraph,
  is_wide,
  is_short,
  global_data,
  alignCenter,
  titleElement,
  titleSecondary,
}: CombinedProps) => {
  const {
    allUnitiesData,
    isLoading: isLoadingUnities,
    isError: _isErrorUnities,
  } = useQueryUnities(developmentID, global_data.pageConfig.keys.tokko)

  const { divisionPath } = global_data
  const [group, setGroup] = useState<any>([])
  const [buttonsFilters, setButtonsFilters] = useState([])
  const [filters, setFilters] = useState(0)
  const [load, setLoad] = useState(false)

  const [isArrowClicked, setIsArrowClicked] = useState(false)

  useEffect(() => {
    if (allUnitiesData) {
      if (global_data.pageConfig.keys.tokko) {
        setGroup(group_Unities(allUnitiesData, filters, []))
      } else {
        setGroup(
          adapt_unities_data(
            allUnitiesData.filter(
              (unity: { room_amount: number; is_active: boolean }) =>
                (filters === 0 || filters === unity.room_amount) && unity.is_active === true,
            ),
          ),
        )
      }
      setLoad(true)
    }
  }, [allUnitiesData, filters])

  useEffect(() => {
    if (global_data.pageConfig.keys.tokko) {
      setButtonsFilters(findEnvironments(allUnitiesData, true))
    } else {
      //@ts-ignore
      setButtonsFilters(findEnvironmentsMediacore(allUnitiesData))
    }
  }, [allUnitiesData, group, filters])

  const updateFilter = (value: number) => {
    if (value === filters) {
      return setFilters(0)
    }
    return setFilters(value)
  }

  return !isLoadingUnities && group?.length === 0 ? (
    ''
  ) : (
    <section
      className={
        'ficha-units a p-y-config ' +
        (is_short ? ' is_short_component ' : '') +
        (is_wide ? ' is_wide_component ' : '')
      }
      id="Unidades"
    >
      <div className="container-fluid">
        <>
          <div
            className={
              'row intro ' +
              (alignCenter ? 'text-center ' : '') +
              (!isLoadingUnities && group?.length === 0 ? 'd-none' : '')
            }
          >
            <div className={is_short ? 'col-lg-2' : 'col-lg-12'}>
              <ElementHTML
                elementType={titleElement || 'h2'}
                className={
                  'section-name ' +
                  (alignCenter ? ' text-center' : '') +
                  (titleSecondary ? ' secondary-color ' : '')
                }
                children={title || 'Unidades'}
              />
            </div>
            <div className={is_short ? 'col-lg-10' : 'col-lg-12'}>
              <p className={alignCenter ? ' text-center' : ''}>{paragraph}</p>
            </div>
            <div className={is_short ? 'col-lg-10 offset-lg-2' : 'col-12'}>
              <div
                className={
                  'd-flex flex-wrap mt-5 ' + (alignCenter ? 'justify-content-center ' : '')
                }
              >
                {isLoadingUnities ? (
                  [1, 2, 3, 4].map((u) => (
                    <div
                      key={u}
                      className={'tag-filter me-3 mb-3 skeleton overflow-hidden'}
                    >
                      {' '}
                      XXXXX
                    </div>
                  ))
                ) : (
                  <>
                    {buttonsFilters.length > 1 && (
                      <div
                        className={
                          'tag-filter proyect-bg me-3 mb-3 ' + (filters === 0 ? ' active ' : '')
                        }
                        onClick={() => updateFilter(0)}
                      >
                        {' '}
                        Todos
                      </div>
                    )}
                    {buttonsFilters.length > 1 &&
                      buttonsFilters.map((element, index) => (
                        // <div className={"tag-filter proyect-bg me-3 mb-3 " + (findEnvironments(allUnitiesData,element) ? '' : ' d-none ' ) + (filters === element ? ' active ' : '')} onClick={() => updateFilter(element)}>{element} Ambiente{element > 1 && 's'}</div>
                        <div
                          key={index}
                          className={
                            'tag-filter proyect-bg me-3 mb-3 ' +
                            (true ? '' : ' d-none ') +
                            (filters === element ? ' active ' : '')
                          }
                          onClick={() => updateFilter(element)}
                        >
                          {element} Ambiente{element > 1 && 's'}
                        </div>
                      ))}
                  </>
                )}
              </div>
            </div>
          </div>
          <div
            className={
              'row table-row ' +
              (alignCenter ? 'justify-content-center ' : '') +
              (!isLoadingUnities && group?.length === 0 ? 'd-none' : '')
            }
          >
            <div
              className={
                ' mt-lg-5 ' +
                (is_short
                  ? (is_wide ? 'col-lg-10' : 'col-lg-8') + ' offset-lg-2 '
                  : is_wide || !alignCenter
                  ? 'col-lg-10'
                  : 'col-lg-8')
              }
            >
              {isLoadingUnities ? (
                <div
                  className="skeleton w-100"
                  style={{ height: '2rem' }}
                ></div>
              ) : (
                <>
                  {group && load
                    ? group.map((item: { floor: string; unities: any }, index: number) => (
                        <div
                          key={index}
                          className={'unity'}
                          style={{ zIndex: '5' }}
                        >
                          <div
                            className="head-row row collapsed"
                            data-bs-toggle="collapse"
                            onClick={() => setIsArrowClicked(!isArrowClicked)}
                            data-bs-target={'#collapseExample' + index}
                            aria-expanded="false"
                            aria-controls={'collapseExample' + index}
                            key={index}
                          >
                            <div className="col-lg-2 col-2 pe-0 pe-lg-2">
                              <span className="unity-font">{item.floor}</span>
                            </div>
                            <div
                              className="col-lg-1 px-0 col-3 d-none d-lg-block"
                              style={{ textAlign: 'center' }}
                            >
                              <span
                                className="unity-font sub-title"
                                style={{ minWidth: '5rem', textAlign: 'center' }}
                              >
                                Ambientes
                              </span>
                            </div>
                            <div
                              className="col-lg-2 col-3 d-none d-lg-block"
                              style={{ textAlign: 'center' }}
                            >
                              <span
                                className="unity-font sub-title"
                                style={{ minWidth: '5rem', textAlign: 'center' }}
                              >
                                {false ? 'Disponible' : 'Sup. cubierta'}{' '}
                              </span>
                            </div>
                            <div
                              className="col-lg-2 col-2 px-0 px-lg-2"
                              style={{ textAlign: 'center' }}
                            >
                              <span
                                className="unity-font sub-title"
                                style={{ minWidth: '5rem', textAlign: 'center' }}
                              >
                                Sup. Total{' '}
                              </span>
                            </div>
                            <div
                              className="col-lg-2 col-3 d-lg-block"
                              style={{ textAlign: 'center' }}
                            >
                              <span
                                className="unity-font sub-title"
                                style={{ minWidth: '5rem', textAlign: 'center' }}
                              >
                                Operación
                              </span>
                            </div>
                            <div
                              className="col-lg-2 col-3"
                              style={{ textAlign: 'center' }}
                            >
                              <span
                                className="unity-font sub-title"
                                style={{ minWidth: '5rem', textAlign: 'center' }}
                              >
                                Precio{' '}
                              </span>
                            </div>
                            <div
                              className="col-lg-1 col-1"
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                              }}
                            >
                              <i className={'icon-arrow'}></i>
                            </div>
                          </div>
                          <div
                            className="close-deployable collapse pb-3"
                            id={'collapseExample' + index}
                          >
                            {/* {item.unities.sort((a, b) => a.address.split(" ")[1]?.localeCompare(b.address.split(" ")[1])).map((element,index) => (                // SOLUCIÓN                          */}
                            {item.unities.map((element: any, index: number) => (
                              <div key={index}>
                                <>
                                  <Link
                                    className={
                                      element.status === 2 ||
                                      element.availability.toLowerCase() === 'disponible'
                                        ? ''
                                        : 'disabled-row'
                                    }
                                    to={
                                      element.status === 2 ||
                                      element.availability.toLowerCase() === 'disponible'
                                        ? (divisionPath ?? '') +
                                          '/propiedad/' +
                                          element.operations[0]?.operation_type?.toLowerCase() +
                                          '/' +
                                          element.fake_address
                                            .toLowerCase()
                                            .replaceAll(' ', '-')
                                            .normalize('NFD')
                                            .replace(/[\u0300-\u036f]/g, '') +
                                          '/' +
                                          element.id
                                        : ''
                                    }
                                  >
                                    <div
                                      className={
                                        'unity-row unit row ' +
                                        (element.status === 2 ||
                                        element.availability.toLowerCase() === 'disponible'
                                          ? ''
                                          : 'disabled')
                                      }
                                    >
                                      <div className="col-lg-2 col-2 pe-0 pe-lg-2">
                                        <span
                                          className={
                                            'ms-lg-0 unity-yellow-font montserrat-regular proyect-color'
                                          }
                                        >
                                          {element.address}
                                        </span>
                                      </div>
                                      <div
                                        className="col-lg-1 px-0 col-3 d-none d-lg-block"
                                        style={{ textAlign: 'center' }}
                                      >
                                        <span
                                          className="unity-font montserrat-regular proyect-color"
                                          style={{ minWidth: '5rem', textAlign: 'center' }}
                                        >
                                          {element.rooms}
                                          <sup></sup>
                                        </span>
                                      </div>
                                      <div
                                        className="col-lg-2 col-4 d-none d-lg-block"
                                        style={{ textAlign: 'center' }}
                                      >
                                        <span
                                          className="unity-font montserrat-regular proyect-color"
                                          style={{ minWidth: '5rem', textAlign: 'center' }}
                                        >
                                          {false ? (
                                            element.availability.toLowerCase() === 'disponible' ? (
                                              'Si'
                                            ) : (
                                              'No'
                                            )
                                          ) : (
                                            <>
                                              {`${element.surface}m`}
                                              <sup>2</sup>
                                            </>
                                          )}{' '}
                                        </span>
                                      </div>
                                      <div
                                        className="col-lg-2 col-2 px-0 px-lg-2"
                                        style={{ textAlign: 'center' }}
                                      >
                                        <span
                                          className="unity-font montserrat-regular proyect-color"
                                          style={{ minWidth: '5rem', textAlign: 'center' }}
                                        >
                                          {element.surface_total} m<sup>2</sup>
                                        </span>
                                      </div>
                                      <div
                                        className="col-lg-2 col-3 d-lg-block"
                                        style={{ textAlign: 'center' }}
                                      >
                                        <span
                                          className="unity-font montserrat-regular proyect-color ms-lg-0 me-lg-0"
                                          style={{ textAlign: 'center' }}
                                        >
                                          {element.operations.map(
                                            (o: { operation_type: string }, index: number) => (
                                              <Fragment key={index}>
                                                {getShortOperation(o.operation_type)}{' '}
                                                <div
                                                  className={
                                                    index === element.operations.length - 1
                                                      ? 'd-none'
                                                      : ''
                                                  }
                                                >
                                                  {/* <br /> */}
                                                </div>
                                              </Fragment>
                                            ),
                                          )}
                                        </span>
                                      </div>
                                      <div
                                        className="col-lg-2 col-3 px-0 px-lg-2"
                                        style={{ textAlign: 'center' }}
                                      >
                                        <span
                                          className="unity-font montserrat-regular proyect-color"
                                          style={{ minWidth: '5rem', textAlign: 'center' }}
                                        >
                                          {element.show_price || element.web_price
                                            ? element.operations.map((o: any, index: number) => (
                                                <Fragment key={index}>
                                                  {`${o.prices.currency} ${Intl.NumberFormat(
                                                    'de-DE',
                                                  ).format(o.prices.price)}`}{' '}
                                                  <div
                                                    className={
                                                      index === element.operations.length - 1
                                                        ? 'd-none'
                                                        : ''
                                                    }
                                                  >
                                                    {/* <br /> */}
                                                  </div>
                                                </Fragment>
                                              ))
                                            : 'A Consultar'}
                                          {/* {element.currency} {element.price > 0 ? new Intl.NumberFormat("de-DE").format(element.price) : element.price} */}
                                        </span>
                                      </div>
                                      {/* <div className="col-2 col-lg-1 my-auto round"><Link to={("/propiedad/" + element.operations[0]?.operation_type?.toLowerCase() + "/" + element.fake_address.toLowerCase().replaceAll(" ","-") + "/" + element.id)} className="icon-arrow"></Link></div> */}
                                    </div>
                                  </Link>
                                </>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))
                    : ''}
                  <div
                    className={
                      'col-10 m-auto text-center' + (group.length === 0 ? '  ' : ' d-none')
                    }
                  >
                    <p
                      className="disabled-unities text-center"
                      style={{ fontSize: '1rem', margin: '0rem 0', maxWidth: '' }}
                    >
                      No hay resultados para tu busqueda.
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      </div>
    </section>
  )
}

export default UnitiesDevelopment_1
